import React, { forwardRef, memo } from 'react';
import cn from 'classnames';

import { Image } from 'components';

import { Button } from 'components/form';

import styles from './ImageUpload.module.scss';

export interface ImageUploadProps {
  /** Custom class name */
  className?: string;
  /** Custom style */
  style?: Record<string, unknown>;
  /** image url */
  image: string;
  //* alternate string */
  alt: string;
}

export const ImageUpload: React.FC<ImageUploadProps> = memo(
  forwardRef<HTMLInputElement, ImageUploadProps>(
    (
      {
        className = '', // custom class name
        style, // custom style
        image,
        alt,
        ...props
      },
      ref
    ) => {
      const contentClassNames = cn(styles.ImageUpload, className);

      return (
        <div
          className={contentClassNames}
          style={style}
          data-testid="ImageUpload"
        >
          <Image src={image} alt={alt} />
          <input
            type="file"
            accept="image/*"
            id="upload-image"
            ref={ref}
            hidden
            {...props}
          />
          <Button color="primary-light" className={styles.ImageUploadButton}>
            <label htmlFor="upload-image">Upload a new picture</label>
          </Button>
        </div>
      );
    }
  )
);

ImageUpload.displayName = 'ImageUpload';
